/**
 * Validates if an object has the expected worklog structure
 * @param {any} obj - The object to validate
 * @returns {boolean} - True if valid worklog structure
 */
export const isValidWorklog = (obj) =>
  obj &&
  typeof obj.id === 'number' &&
  typeof obj.time_spent === 'number' &&
  typeof obj.description === 'string' &&
  typeof obj.report === 'number' &&
  typeof obj.issue === 'number' &&
  typeof obj.date === 'string';
